<template>
	<div class="weather-promos">
		<template>
			<div class="banner-wrapper">
				<div class="overlay-wrapper">
					<h2>{{ getHeading }}</h2>
					<p>{{ getOverlaySubheader }}</p>
				</div>
			</div>
			<div class="weather-info-wrapper">
				<div class="current-weather">
					<p class="weather-title">{{ content.weatherPromos.currentWeather }}<span
							class="mobile-only">-</span><span class="store-name">{{ weather.storeName }}</span></p>

					<div v-if="firstDay" class="first-day-wrapper">
						<div class="first-day">
							<p class="currTemp">{{ weather.weatherInfo.currTemp }}&deg;</p>
							<img :alt="getCondition(firstDay)" :src="getWeatherIcon(firstDay.conditionEn)">
						</div>
						<div class="temp">
							<p class="high">
								<span class="label">H:</span>
								<span class="temp-value">{{ formatTemp(firstDay.maxTemp) }}</span>&deg;
							</p>
							<p class="low">
								<span class="label">L:</span>
								<span class="temp-value">{{ formatTemp(firstDay.minTemp) }}</span>&deg;
							</p>
						</div>
					</div>
				</div>
				<div class="week-forecast">
					<p class="weather-title">{{ content.weatherPromos.weekForecast }}</p>
					<div class="weekly-weather-wrapper">
						<div v-for="(day, index) in weather.weatherInfo.daysWeatherInfo" :key="index"
						     class="weather-day">
							<p class="day">{{ formatDay(index, day.day) }}</p>
							<img :alt="getCondition(day)" :src="getWeatherIcon(day.conditionEn)">
							<div class="temp">
								<p class="high">
									<span class="label">H:</span>
									<span class="temp-value">{{ formatTemp(day.maxTemp) }}</span>&deg;
								</p>
								<p class="low">
									<span class="label">L:</span>
									<span class="temp-value">{{ formatTemp(day.minTemp) }}</span>&deg;
								</p>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="product-grid">
				<div v-for="(product, index) in products" :key="index" :class="{ 'flex-50': products.length === 4, 'flex-30': products.length <= 6 && products.length > 4 }" class="product-card"
				     tabindex="0">
					<div class="content">
						<div class="product-image">
							<img :src="product.productImage" alt="">
						</div>

						<p class="product-name">{{ product.brandDescription }}</p>
						<p v-if="product.saveInt !== 0" class="savings">{{ content.weatherPromos.save }} {{
								product.save
							}}</p>
						<p class="product-desc">{{ productDesc(product) }}</p>

					</div>
					<div>
						<p class="product-sku">{{ product.sku }}</p>
					</div>
					<div v-if="isVisible">
						<product-click-regions :key="product.sku + index" :block="block" :block-data="blockData"
						                       :is-visible="isVisible" :page="page" :product="product" class="overrideStyles"
						                       @onRegionClick="handleDynamicPromoClick(product)" v-on="$listeners"/>

					</div>
				</div>

			</div>

		</template>
	</div>
</template>

<script>
import {mapGetters, mapState, mapActions} from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import {PRODUCT_REGION_CLICK} from "@/components/block/BlockEvents";
import ProductClickRegions from "@/components/block/elements/ProductClickRegions.vue";
import Lytics from "../../classes/Lytics";


export default {
	name: "WeatherPromos",
	mixins: [blockElementMixin],
	components: {ProductClickRegions,},
	data() {
		return {
			products: [],
			weather: {
				weatherInfo: []
			},
			finelineNMs: [],
			lastcategory: [],
			validConditionsWinter: false,
		}
	},
	created() {

		const weatherpage = this.pages.find(page => page.id === 'weatherPromos')
		if (weatherpage) {
			this.weather = weatherpage.data
			this.validConditionsWinter = weatherpage.validConditionsWinter
			this.finelineNMs = this.weather.finelineNMs;
		}
		this.fetchProducts();

	},
	watch: {
		isVisible(newVal) {
			if (newVal) {
				this.products.forEach((product) => {
					Lytics.TriggerDynamicPromoImpression({
						id: product.sku,
						name: product.productEn,
						img: product.productImage,
						type: "weather"
					})
				});
			}
		}
	},
	computed: {
		...mapState(['pages']),
		...mapGetters('ctUser', ['canViewTriangleRewards', 'isSignedIn', 'offerViewMode', 'hasOffers', 'isLoggedIntoCT', 'hasTriangleID']),
		...mapGetters(['content', 'language', 'storeId']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('landingPage', ['currentFlyer']),
		isVerticalOnDesktop() {
			return this.displayMode === 'desktop' && this.flyerOrientation === 'vertical';
		},
		firstDay() {
			return this.weather?.weatherInfo?.daysWeatherInfo?.length ? this.weather?.weatherInfo?.daysWeatherInfo[0] : null;
		},
		isTuesday() {
			const today = new Date();
			const dayOfWeek = 2;
			return today.getDay() === dayOfWeek;
		},
		isPreviewFlyer() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === 'preview';
		},
		getHeading() {
			let heading = this.content.weatherPromos
			return this.validConditionsWinter ? heading.overlayHeadingWinter : heading.overlayHeadingSpring;
		},
		getOverlaySubheader() {
			let subheading = this.content.weatherPromos
			return this.validConditionsWinter ?
				(this.currentFlyer.province === 'QC' ? subheading.subcopyWinterQuebec : subheading.overlaySubcopyWinter)
				: subheading.overlaySubcopySpring;
		},
	},
	methods: {
		...mapActions('events', ['triggerEvent']),
		getWeatherIcon(condition) {
			const iconMap = {
				sunny: '/icons/weather/sunny.png',
				'partly-cloudy': '',
				cloudy: '/icons/weather/cloudy.png',
				rain: '/icons/weather/rain.png',
				storm: '/icons/weather/storm.png',
				drizzle: '/icons/weather/light-showers.png',
				snow: '/icons/weather/snow.png',
				sleet: '/icons/weather/sleet.png',
				overcast: '/icons/weather/overcast.png',
				ice: '/icons/weather/freezingRain.png',
				freezing: '/icons/weather/freezing.png',
				mist: '/icons/weather/mist.png',
				blizzard: '/icons/weather/snowstorm.png',
				fog: '/icons/weather/fog.png'

			}

			for (const key in iconMap) {
				if (condition.toLowerCase().includes(key)) {
					return iconMap[key];
				}
			}
		},
		formatTemp(temp) {
			return temp < 10 ? ` ${temp}` : `${temp}`
		},
		formatDay(index, day) {
			let dayLower = day.toLowerCase();
			let finalDay
			if (index === 0) {
				return (this.language === 'en') ? 'Today' : `Aujourd'hui`
			}
			if (this.language === 'fr') {
				if (dayLower === 'monday') finalDay = 'Lundi'
				if (dayLower === 'tuesday') finalDay = 'Mardi'
				if (dayLower === 'wednesday') finalDay = 'Mercr.'
				if (dayLower === 'thursday') finalDay = 'Jeudi'
				if (dayLower === 'friday') finalDay = 'Vendr.'
				if (dayLower === 'saturday') finalDay = 'Sam.'
				if (dayLower === 'sunday') finalDay = 'Dim.'

			} else {
				finalDay = dayLower === 'thursday' ? day.slice(0, 4) : day.slice(0, 3)
			}
			return finalDay
		},

		getCondition(day) {
			return (this.language === 'fr') ? day.conditionFr : day.conditionEn
		},

		fetchProducts() {
			const pages = this.pages || [];
			const finelineNMs = this.finelineNMs?.map(f => f.toLowerCase())
			pages.find((page) => {
				page.blocks.find((block) => {
					block.products.find((product) => {
						const lastcategory = product?.categories[product?.categories?.length - 1];
						const lowerCase = lastcategory?.toLowerCase();
						if (finelineNMs.includes(lowerCase)) {
							if (product.productImage) {
								this.products.push(product);
							}
						}
					})
				})
			})

			this.filterProducts();
		},
		filterProducts() {
			const limit = (this.displayMode === 'mobile') ? 6 : 8;
			this.products = this.products.sort((a, b) => b.saveInt - a.saveInt)
			this.products = [...this.products.slice(0, limit)]
		},

		productDesc(product) {
			return (this.language === 'fr') ? product.productFr : product.productEn;
		},
		onClick(product) {
			this.triggerEvent({'event': PRODUCT_REGION_CLICK, data: product})
			this.$emit('onRegionClick', this, 'productRegion');
		},
		handleDynamicPromoClick(product) {
			Lytics.TriggerDynamicPromoClick({
				id: product.sku,
				name: product.productEn,
        img: product.productImage,
        link_name: "",
        type: "weather"
			})
		}
	},
}
</script>

<style lang="scss">
.weather-promos {
  --red-color: #ff2e17;
  --grey-color: #D3D3D3;
  display: grid;
  border: 1px solid rgb(216, 216, 216);
  width: 100%;
  height: 100%;

  .banner-wrapper {
	position: relative;
	background: #f7f7f7;
	padding: 6% 0;
	border-bottom: 1px solid rgb(216, 216, 216);

	.overlay-wrapper {
	  position: absolute;
	  left: 5%;
	  top: 12%;
	  color: #000;
	  max-width: unset;

	  h2 {
		color: var(--red-color);
		font-size: 1.1rem;
	  }

	  p {
		font-size: 0.65rem;
		margin-top: 8px;
	  }
	}
  }

  img {
	width: 100%;
	height: auto;
  }

  .weather-info-wrapper {
	display: flex;
	font-size: 9px;
	//padding: 10px 0;
	padding: 5px 0;
	background: #fff;

	.current-weather,
	.week-forecast {
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: center;

	  .weather-title {
		font-family: 'Lato Bold', sans-serif;
		display: flex;
		flex-direction: column;
		align-items: center;

		.mobile-only {
		  display: none;
		}

		.store-name {
		  display: block;
		}

	  }
	}


	.current-weather {
	  flex: 1;
	  position: relative;
	  margin-left: 10px;

	  &::after {
		content: "";
		position: absolute;
		width: 1px;
		background: rgb(216, 216, 216);
		height: 86%;
		top: 6%;
		right: -5px;

	  }

	  .first-day-wrapper {

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 8px;

		.first-day {
		  display: flex;
		  align-items: center;
		  justify-content: center;

		  p {
			font-family: 'Lato Bold', sans-serif;
			font-size: 19px;
		  }

		  img {
			width: 35px;
			height: 25px;
		  }
		}

		.temp {
		  width: 100%;
		  font-size: 13px;
		  max-width: 45px;

		  .label {
			font-family: 'Lato Bold', sans-serif;
			margin-right: 2px;
		  }

		  .temp-value {
			display: inline-block;
			min-width: 2ch;
			text-align: right;
		  }

		  .low {
			.label {
			  margin-right: 4px;
			}
		  }
		}
	  }


	}

	.week-forecast {
	  flex: 3;

	  .weekly-weather-wrapper {
		display: flex;
		gap: 5px;
		margin-top: 10px;

		.weather-day {
		  display: flex;
		  flex-direction: column;
		  align-items: center;

		  img {
			width: 35px;
			height: 25px;
			margin: 6px 2px;
		  }

		  .temp {
			width: 100%;
			max-width: 35px;

			.label {
			  font-family: 'Lato Bold', sans-serif;
			  margin-right: 2px;
			}

			.temp-value {
			  display: inline-block;
			  min-width: 2ch;
			  text-align: right;
			}

			.low {
			  .label {
				margin-right: 4px;
			  }
			}
		  }
		}


	  }
	}
  }

  .product-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	//grid-template-rows: repeat(2, 138px);
	// display: flex;
	// flex-wrap: wrap;
	border-top: 1px solid rgb(216, 216, 216);
	padding: 2px 2px;
	background-color: #f7f7f7;

	.product-card.flex-30 {
	  flex: 30%;
	}

	.product-card.flex-50 {
	  flex: 45%;
	}

	.product-card {
	  display: flex;
	  flex-direction: column;
	  border: 1px solid rgb(216, 216, 216);
	  padding: 7px;
	  margin: 3px 3px;
	  background-color: #fff;
	  position: relative;
	  cursor: pointer;

	  .content {
		flex: 1;

		.product-image {
		  max-height: 78px;
		  display: flex;
		  border: 1px solid rgb(216, 216, 216);

		  img {
			padding: 6px 0;
			object-fit: contain;
		  }
		}

		.product-name {
		  margin: 5px 0;
		  font-size: 8px;
		  text-transform: uppercase;
		}

		.savings {
		  color: var(--secondary-color);
		  font-family: 'Lato Bold', sans-serif;
		  text-transform: uppercase;
		  font-size: 12px;
		  margin: -3px 0;
		}

		.product-desc {
		  line-height: 8px;
		  font-size: 8px;
		  margin-top: 5px;
		  color: #262626;
		  display: -webkit-box;
		  -webkit-line-clamp: 2;
		  -webkit-box-orient: vertical;
		  overflow: hidden;
		  text-overflow: ellipsis;
		}


	  }

	  .product-sku {

		margin-top: 3px;
		font-size: 8px;
		color: #262626;


	  }

	  .overrideStyles.product-click-regions {
		background: red;

		.product-click-region {
		  position: absolute;
		  top: 0 !important;
		  left: 0 !important;
		  width: 100% !important;
		  height: 100% !important;
		  z-index: 99 !important;
		}
	  }
	}
  }

  .cta-banner-wrapper {
	// background: var(--secondary-color);
	// width: 96%;
	// margin: 0 auto;
	// display: flex;
	// justify-content: center;
	// align-items: center;
	// min-height: 23px;

	p {
	  color: #fff;
	  text-align: center;
	  font-size: 0.55em;

	  span {

		a {
		  color: #fff;
		}
	  }
	}
  }

  .legal-copy {
	padding: 0 10px;

	p {
	  font-size: 8px;
	}
  }

}

@keyframes pulse {
  0% {
	transform: scale(1);
	box-shadow: 0 0 0 0 rgba(238, 49, 36, 0.7);
  }
  50% {
	transform: scale(1.05);
	box-shadow: 0 0 0 20px rgba(238, 49, 36, 0);
  }
  100% {
	transform: scale(1);
	box-shadow: 0 0 0 0 rgba(238, 49, 36, 0);
  }
}
</style>

<style lang="scss">
[mode='mobile'] [page-id='weatherPromos'].section-container {
  position: relative;

  & > .flyer-block.WeatherPromos {
	grid-area: span 4 / span 2 / auto / auto !important;

	.banner-wrapper {
	  padding: 2.8rem 0;
	  min-height: 3rem;

	  .overlay-wrapper {
		top: 18%;

		h2 {
		  font-size: 1rem;
		  max-width: 19rem;
		}

		p {
		  line-height: 14px;
		  max-width: 20rem;
		}
	  }
	}

	.weather-info-wrapper {
	  font-size: 0.8em;
	  flex-direction: column;

	  img {
		width: 43px;
		height: 33px;
	  }

	  .current-weather {
		margin-top: 10px;
		padding-bottom: 24px;

		&::after {
		  width: 88%;
		  height: 1px;
		  top: 88%;
		  right: 25px;
		}

		.weather-title {
		  display: block;

		  .mobile-only {
			margin: 0 5px;
			display: inline-block;
		  }

		  .store-name {
			display: inline-block;
		  }
		}

		.first-day-wrapper {
		  flex-direction: row;

		  .temp {
			margin-left: 5px;
			font-size: 1.1em;

			.high {
			  margin-right: 5px;
			}
		  }
		}
	  }

	  .week-forecast {
		flex: unset;
		padding: 8px;
	  }
	}

	.product-grid {
	  grid-template-columns: repeat(2, 1fr);

	  .product-card {


		.content {

		  .product-name {
			font-size: 0.8em;

		  }

		  .savings {
			font-size: 1.2em;
		  }

		  .product-desc {
			font-size: 0.7em;
			line-height: 13px;
		  }
		}

		.product-sku {
		  font-size: 0.7em;
		}
	  }
	}


  }

  .cta-banner-wrapper {
	p {
	  font-size: 0.7em;
	  max-width: 35%;
	  padding: 5px 0;

	  .desktop-only {
		display: none;
	  }

	  span {
		display: block;
	  }
	}

  }


}

[mode='tablet'] [page-id='weatherPromos'].section-container {
  position: relative;

  & > .flyer-block.WeatherPromos {
	grid-area: span 4 / span 3 / auto / auto !important;

	.weather-info-wrapper {
	  font-size: 0.9em;
	  padding: 15px 0;
	  // max-height: 85px;

	  img {
		width: 50px;
		height: 35px;
	  }
	}

	.banner-wrapper {
	  padding: 6.5% 0;

	  .overlay-wrapper {
		h2 {
		  font-size: 20px;
		}
	  }
	}

	.product-grid {
	  padding: 8px 4px;

	  .product-card {
		.content {

		  .product-name {
			font-size: 0.8em;
		  }

		  .savings {
			font-size: 1.1em;
		  }

		  .product-desc {
			font-size: 0.8em;
			line-height: 13px;
		  }

		  .product-image {
			max-height: 115px;
		  }
		}

		.product-sku {
		  font-size: 0.8em;
		}
	  }
	}
  }

  .cta-banner-wrapper {
	max-height: 27px;

	p {
	  font-size: 0.8em;
	}
  }

}

[mode='desktop'] [flyer-orientation='vertical'] [page-id='weatherPromos'].section-container {
  position: relative;

  & > .flyer-block.WeatherPromos {
	grid-area: span 3 / span 3 / auto / auto !important;

	.banner-wrapper {
	  padding: 4% 0;
	}

	.cta-banner-wrapper {
	  min-height: unset;
	  max-height: 32px;
	  width: 97.5%;

	  p {
		font-size: 0.75em;
	  }
	}

	.weather-info-wrapper {
	  font-size: 0.8em;

	  img {
		width: 53px;
		height: 36px;
	  }

	  .first-day-wrapper {
		margin-top: 15px;
	  }
	}

	.product-grid {
	  .product-card {
		.content {
		  .product-image {
			max-height: 105px;
		  }

		  .product-name {
			font-size: 10px;
		  }

		  .savings {
			font-size: 14px;
		  }

		  .product-desc {
			font-size: 10px;
			line-height: 12px;
		  }
		}

		.product-sku {
		  font-size: 10px;
		}
	  }
	}
  }
}
</style>
